import React from 'react';
import { useTranslation } from 'react-i18next';
import { EpdLinks } from 'routes/EpdRoutes';
import { Container, MainView, StyledLink } from 'styles/Styles.styled';

import styled from 'styled-components';

const Welcome: React.FunctionComponent = () => {
  const { t } = useTranslation();

  return (
    <Container>
      <MainView>
        <OldCardStyles>
          <h2>{t('epdDashboard.userHasNoCompanies.welcomeToPortal')}</h2>
          <div>
            In order to get started using EPD portal you need to belong to one or more organisations, you can either
            <br />
            <p>
              <StyledLink to={EpdLinks.organisation('connect')}>
                {t('epdDashboard.userHasNoCompanies.connectToOrg')}
              </StyledLink>
            </p>
            <p>
              <StyledLink to={EpdLinks.organisation('create')}>{t('epdDashboard.userHasNoCompanies.createOrg')}</StyledLink>
            </p>
          </div>
        </OldCardStyles>
      </MainView>
    </Container>
  );
};

const OldCardStyles = styled.div`
  flex: 1 0 auto;
  text-align: center;
  margin: 2rem;
`;

export default Welcome;
